/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as queryString from 'query-string';

import { fetchMatchingProfilesById } from '../../actions/get-rated-actions';
import { setPlayerId } from '../../actions/profile-actions';
import { setClaimedPlayerId } from '../../actions/onboarding-actions';

// HOC presets the claimed player for the onboarding flow if "activateId" query param is found
// otherwise it passes down the required reducers to the child components

export default (ChildComponent) => {
    class PresetClaimedUser extends Component {
        componentDidMount() {
            const { location, profile, matchedProfiles, auth, onboarding } = this.props;
            const { profiles } = matchedProfiles;
            const parsed = queryString.parse(location.search);
            const { activateId } = parsed;
            if (!onboarding.playerId && activateId) {
                // set playerId in onboarding reducer (toggles the preset flow during onboarding)
                this.props.setClaimedPlayerId(activateId);
            }
            if (onboarding.playerId) {
                // set playerId in profile reducer (load profile)
                if (!profile.data.id || (profile.data && profile.data.id && profile.data.id.toString() !== onboarding.playerId)) {
                    this.props.setPlayerId(onboarding.playerId);
                }
                // preload matching profile by id
                if (auth.user && (!profiles.length || (profiles.length && profiles[0].id.toString() !== onboarding.playerId))) {
                    this.props.fetchMatchingProfilesById(onboarding.playerId);
                }
            }
        }

        render() {
            return (<ChildComponent {...this.props} />);
        }
    }

    function mapDispatchToProps(dispatch) {
        return {
            setPlayerId: (playerId) => dispatch(setPlayerId(playerId, true)),
            setClaimedPlayerId: (playerId) => dispatch(setClaimedPlayerId(playerId)),
            fetchMatchingProfilesById: (id) => dispatch(fetchMatchingProfilesById(id)),
        };
    }

    function mapStateToProps({ profile, onboarding, matchedProfiles, auth }) {
        return { profile, onboarding, matchedProfiles, auth };
    }

    return connect(mapStateToProps, mapDispatchToProps)(withRouter(PresetClaimedUser));
};
